/**
 * @title digital-membership-card.js: Sub-module for Account pages
 * @description This module is used to handle tasks on Account -> Digital Membership Card
 * @dependency 
 */
define([], function() {

let DigitalMembershipCard = {

	//Each redirection ends up on same page -> DigitalMembershipCardView (DigitalMembershipCardBody.jsp) with different flowId
	// Depending on flow and device type user get different functionalities. 
	flowId: '',
	//Below is list of all flows that JS handles. There are some flows that are not handled by JS logic
	// There are some flows like session-expire that are still not in JS but it should be. TODO  
	FLOWS: { 
		// OTP flow
		YELLOW_FLOW: 'otp',
		// After successfully received SMS token 
		YELLOW_FLOW_TOKEN: 'otpValidate',
		// ERROR Flows
		TRY_AGAIN: 'tryAgainAction',
		TRY_AGAIN_BAD_REQUEST: 'tryAgainActionBadRequest',
		OTP_TRY_AGAIN: 'tryAgainOTPAction',
		DEPROVISION_TRY_AGAIN: 'tryAgainDeprovisionAction',
		RED_FLOW: 'RED',
		// ERROR Flows in OTP flow
		MAXIMUM_ATTEMPTS_LIMIT_EXCEEDED: 'maximumAttemptsLimitExceeded',
		RED_OTP_EXPIRE: 'expireOTP',
		RED_UNVERIFIED_PHONE: 'unverifiedPhone',
		UN_AUTHORIZED: 'unAuthorized',
		INVALID_REQUEST: 'invalidRequest',
		INVALID_OTP: 'invalidOTP',
		SESSION_EXPIRE: 'sessionExpire',
		
	},
	
	// Template names
	// Cvv screen for provisioning of cards
	dmcCvvScreenTemplate: 'dmc_add_CC_form_tmpl',
	// Main template that contain image title text and action buttons. 
	dmcProvisionMainTemplate: 'dmc_CC_provisioning_form_tmpl',
	// Error template that gets loaded into main template 
	dmcProvisionRedPathTemplate: 'dmc_CC_provisioning_red_path_tmpl',
	// OTP template that contain choose buttons gets loaded into main template
	dmcProvisionOtpChooseTemplate: 'dmc_CC_provisioning_yp_choose_tmpl',
	// OTP second screen template that contains sms token form gets loaded into main template
	dmcProvisionAddSMSTokenTemplate: 'dmc_CC_provisioning_yp_add_token_tmpl',
	// Load template as body of a dialog
	dmcDialogTemplate: 'dmc_dialog_tmpl',

	// Selectors for div's and button
	dmcContent: '#dmc-content',
	dmcProvisioningContent: '#dmc-cc-provisioning-content',
	// Based on flow dmc actions button has different values and is binded to different actions.
	// It is used as continue button in different flows and it can be used as Back To Digital Membership button. 
	dmcActionsButton: '#dmc-cc-actions-button',
	dmcCancelButton: '#dmc-cancel-cc-button',
	dmcChooseButton: '.dmc-radio-button',
	// Back to DMC title
	dmcBackToDMCTitle: 'Return to Digital Membership',
	dmcBackToDMCClass: 'back-to-dmc', 
	dmcPaymentTitle: '#dmc-payment-title',
	dmcOTPContinue: 'continue-button', 
	dmcValidationCodeExpired: 'dmcValidationCodeExpired',
	dmcValidationCodeExpTime: 'dmcValidationCodeExpTime',
	dmcCountDownFinishedMessage: '0 minutes and 0 seconds',	
	dmcTimer: '#timer',
	dmcAddTokenForm: '#dmc-yp-add-token-form',
	dmcDialogForm: '#dmc-dialog-form',
	dmcRedPathForm: '#dmc-red-path-form',
	dmcSmsOptions: '#dmc-sms-option',
	dmcVoiceOptions: '#dmc-voice-option',
	cvvNumber: '#cvvNumber',
	aliasId: '#aliasId',
	otpDeliveryOption: '#otpDeliveryOption',
	verificatonMethodSms: '#verificaton-method-sms',
	verificatonMethodVoice: '#verificaton-method-voice',
		  
	/**
	 * Initialization of the module.
	 */
    init: function() {
    
		// Load functionality and layout for mobile browser and mobile redirected from COSTCO app.
		$(document).ready(function() {
			$('#dmc-bottom-divider').show();
			if (COSTCO.Navigation_v2.isPhoneView()) {
				// If user comes from mobile APP provision of card should be available. 
		    	if ($('#deviceType').val() != 'web-app') { 
		    		DigitalMembershipCard.flowId = $('#flowId').val();
					DigitalMembershipCard.loadDmcPaymentMobileView();
				}
			} else {
				DigitalMembershipCard.loadDmcPaymentWebView();
			}
			$('.dmc-box img').attr('alt', '');
			$('#cardExpiryDate').unmask().mask('00/00');
			$('#postalCode').unmask().mask('00000');
			$('#dmc-sms-token').unmask().mask('000000000000000');
			$('#cvvNumber').unmask().mask('000');
			// Takes max height of card and apply that height to oder cards
			$(window).on('load', function () {
				setTimeout(DigitalMembershipCard.alignCardsBox, 200);
		    });
	    });
		COSTCO.MemberVerification.init();
	},
	
	/**
	 *  This method contains main logic for users that are redirected from mobile application. 
	 *  Based on flowId returned from backend commands particular templates are loaded, and 
	 *  required classes and button behaviors  are changed accordingly.
	 *  Also after execution of logic binding of events is done.
	 *    
	 * */
	loadDmcPaymentMobileView: function() {
		$('#header-title').hide();
		$('#topnav').hide();
		$('.mini-banner').hide();
		DigitalMembershipCard.dmcRemoveHiddenClass(DigitalMembershipCard.dmcActionsButton);
		DigitalMembershipCard.dmcRemoveHiddenClass('.dmc-set-as-default');
		$('#dmc-bottom-divider').hide();
		    	
		if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.RED_FLOW || 
				DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.MAXIMUM_ATTEMPTS_LIMIT_EXCEEDED
				|| DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.RED_UNVERIFIED_PHONE
				|| DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.INVALID_REQUEST) {
			
			DigitalMembershipCard.appendDmcTemplate(DigitalMembershipCard.dmcProvisionMainTemplate, DigitalMembershipCard.dmcContent, {});
			$(DigitalMembershipCard.dmcCancelButton).hide();
			$(DigitalMembershipCard.dmcActionsButton).val(DigitalMembershipCard.dmcBackToDMCTitle);
	    	$(DigitalMembershipCard.dmcPaymentTitle).addClass('hidden');
			
	    	if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.MAXIMUM_ATTEMPTS_LIMIT_EXCEEDED) {
	    		DigitalMembershipCard.appendDmcTemplate(DigitalMembershipCard.dmcProvisionRedPathTemplate, DigitalMembershipCard.dmcProvisioningContent, {});
	    		DigitalMembershipCard.dmcRemoveHiddenClass('#dmc-max-attempts-error');
			} else if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.RED_FLOW) { 
				DigitalMembershipCard.loadCVVTemplate();
				$(DigitalMembershipCard.dmcContent).prepend('<p>' + messages.DMC_RED_PATH_ERROR + '</p>');
				$(DigitalMembershipCard.dmcContent + ' > p:eq(0)').addClass('critical-notification');
			} else {
				DigitalMembershipCard.appendDmcTemplate(DigitalMembershipCard.dmcProvisionRedPathTemplate, DigitalMembershipCard.dmcProvisioningContent, {});
				DigitalMembershipCard.dmcRemoveHiddenClass('#dmc-payment-methods-error');
			}
			$(DigitalMembershipCard.dmcActionsButton).addClass(DigitalMembershipCard.dmcBackToDMCClass);
			
		} else if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.YELLOW_FLOW || DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.OTP_TRY_AGAIN) {
			
			$(DigitalMembershipCard.dmcActionsButton).removeClass(DigitalMembershipCard.dmcBackToDMCClass);
			$(DigitalMembershipCard.dmcPaymentTitle).addClass('hidden');
			DigitalMembershipCard.appendDmcTemplate(DigitalMembershipCard.dmcProvisionMainTemplate, DigitalMembershipCard.dmcContent, {});
			DigitalMembershipCard.appendDmcTemplate(DigitalMembershipCard.dmcProvisionOtpChooseTemplate, DigitalMembershipCard.dmcProvisioningContent, DigitalMembershipCard.parameters());
			
			if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.OTP_TRY_AGAIN) {
				$('#dmc-choose-radio-button-group').prepend('<p>' + messages.DMC_TRY_AGAIN_MESSAGE + '</p>');
				$('#dmc-choose-radio-button-group > p:eq(0)').addClass('critical-notification cds-u-space-mt-md cds-u-space-mb-md');
			}		
	    	
		} else if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.YELLOW_FLOW_TOKEN || 
				DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.RED_OTP_EXPIRE ||
				DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.SESSION_EXPIRE ||
				DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.INVALID_OTP) {
			
			$(DigitalMembershipCard.dmcPaymentTitle).addClass('hidden');
			DigitalMembershipCard.appendDmcTemplate(DigitalMembershipCard.dmcProvisionMainTemplate, DigitalMembershipCard.dmcContent, {});
			DigitalMembershipCard.appendDmcTemplate(DigitalMembershipCard.dmcProvisionAddSMSTokenTemplate, DigitalMembershipCard.dmcProvisioningContent, DigitalMembershipCard.parameters());
			$(DigitalMembershipCard.dmcActionsButton).addClass('submit-token');
			
			if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.RED_OTP_EXPIRE ||
				DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.SESSION_EXPIRE ) {
				sessionStorage.setItem(DigitalMembershipCard.dmcValidationCodeExpired, true);
				DigitalMembershipCard.dmcTokenFieldValidation();
				$('#dmc-sms-token').val($('#enteredTokenValue').val());
				$(DigitalMembershipCard.dmcTimer).text(DigitalMembershipCard.dmcCountDownFinishedMessage);
			} else if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.INVALID_OTP ) {
				$('#dmc-sms-token').addClass('error');
				$('#dmc-sms-token-label').addClass('active');
				$('<label for="dmc-sms-token" class="error active" >' + messages.ERR_INVALID_DMC_TOKEN + '</label>').insertAfter('#dmc-sms-token');
				$('#dmc-sms-token').val($('#enteredTokenValue').val());
				DigitalMembershipCard.countDown();
			} else {
				DigitalMembershipCard.countDown();
			} 
		} else if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.TRY_AGAIN_BAD_REQUEST) {
			DigitalMembershipCard.loadCVVTemplate($('#brand').val(), $('#displayAccountNumber').val(), $('#accountHolderName').val());
			$(DigitalMembershipCard.dmcContent).prepend('<p>' + messages.DMC_TRY_AGAIN_CVV_MESSAGE + '</p>');
			$(DigitalMembershipCard.dmcContent + ' > p:eq(0)').addClass('critical-notification');
		}else {
			
			DigitalMembershipCard.dmcRemoveHiddenClass(DigitalMembershipCard.dmcPaymentTitle);
	    	let dmcOneNonProvisionedCard = $('#dmc-one-non-provisioned-card').val();
			if (dmcOneNonProvisionedCard == 'true' || DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.TRY_AGAIN) {
				DigitalMembershipCard.loadCVVTemplate($('#brand').val(), $('#displayAccountNumber').val(), $('#accountHolderName').val());
				if(dmcOneNonProvisionedCard == 'true') {
					$(DigitalMembershipCard.dmcContent).append('<input id="dmc-one-non-provisioned-card" type="hidden" value="true" />');
				}
				if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.TRY_AGAIN) {
					$(DigitalMembershipCard.dmcContent).prepend('<p>' + messages.DMC_TRY_AGAIN_MESSAGE + '</p>');
					$(DigitalMembershipCard.dmcContent + ' > p:eq(0)').addClass('critical-notification');
					$('#cardExpiryDate').val($('#dmcCardExpiryDate').val());
					$('#cardExpiryDateLabel').addClass('active');
					$(DigitalMembershipCard.cvvNumber).val($('#dmcCvvNumber').val());
					$('#cvvNumberLabel').addClass('active');
					$('#postalCode').val($('#dmcPostalCode').val());
					$('#postalCodeLabel').addClass('active');
				} 
			} else if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.DEPROVISION_TRY_AGAIN) {
				$(DigitalMembershipCard.dmcContent).prepend('<p>' + messages.DMC_TRY_AGAIN_DEPROVISION_MESSAGE + '</p>');
				$(DigitalMembershipCard.dmcContent + ' > p:eq(0)').addClass('critical-notification');
			}
			
		}
		
		DigitalMembershipCard.bindDmcEvents();
		
	},
	/**
	 * This method handles the view for users that are using web app.
	 */
	loadDmcPaymentWebView: function() {
		$('#dmc-desc-and-faq').removeClass('dmc-desc-and-faq-hidden')
		$('#dmc-desc-and-faq').addClass('dmc-desc-and-faq-visible');
		$('#dmc-download-app').show();
		$('#dmc-payment-on-application').show();
	},
	
	/**
	 *  This method is used to pass important information as parameters when different templates are loaded 
	 *  forms from those templates are submitted.
	 *  It can be called in different scenarios which requires to be called with some parameters.
	 *  
	 *  @param brand,  displayAccountNumber, accountHolderName
	 *  @return parameters 
	 * */
	parameters: function(brand, displayAccountNumber, accountHolderName) {
		
		let parameters = {
				//data for forms
				ipAddress: $('#ipAddress').val(),
				geoLong: $('#geoLong').val(),
				geoLat: $('#geoLat').val(),
				deviceId: $('#deviceId').val(),
				deviceType: $('#deviceType').val(),
				memberCardNumber: $('#memberCardNumber').val(),
				dmcHash: $('#dmcHash').val(),
				profileId: $('#profileId').val(),
				displayAccountNumber: displayAccountNumber ? displayAccountNumber : $('#displayAccountNumber').val(),
				accountHolderName: accountHolderName ? accountHolderName : $('#accountHolderName').val(),
				otpDeliveryOption: $('#otpDeliveryOption').val(),
				phoneDetails: $('#phoneDetails').val(),
				aliasId: $('#aliasId').val(),
				brand: brand ? brand : $('#brand').val(),
				//testing resopnses
				otpResponse: $('#otpResponse').val(),
				otpMock: $('#otpMock').val(),
				mockresponse:$('#mockresponse').val(),
				otpToken: $('#otpToken').val(),
				doesProvisionedCardExist: $('#doesProvisionedCardExist').val(),
				
		};
		return parameters;
	},
	
	/**
	 *  Cancel button on CVV screen can act differently. In one case when user has one CC it acts like back to membership
	 *  card button. In other case this method stores all CC's to hidden HTML element which is appended back to dmc-content 
	 *  if user click cancel button. 
	 *   
	 * */
	dmcCvvCancel: function() {
		let dmcOneNonProvisionedCard = $('#dmc-one-non-provisioned-card').val();
		if (dmcOneNonProvisionedCard == 'true') {
			DigitalMembershipCard.backToDigitalMembership();
		} else {
			let dmcCobrandedCards = $('#dmc-cc-cards-hidden').html();
			$(DigitalMembershipCard.dmcContent).empty();
			DigitalMembershipCard.dmcRemoveHiddenClass($(DigitalMembershipCard.dmcContent).append(dmcCobrandedCards).find('#dmc-cc-cards-hidden'));
			$(DigitalMembershipCard.dmcActionsButton).show();
			DigitalMembershipCard.bindDmcEvents();
		}
	},
	
	/**
	 * 	Load of CVV screen can be done only for users redirected from mobile APP. It is used for provisioning of CC.
	 *  Can be called from different scenarios so it has params passed. One scenario is when user has only one CC
	 *  which is not defalt one. Other scenario is when user cancel and returns from OTP flow.
	 *  
	 *  Also calls dmcMobileValidation to validate the CVV form.
	 *  
	 *  @param brand, displayAccountNumber, accountHolderName
	 * */
	loadCVVTemplate: function(brand, displayAccountNumber, accountHolderName) {
		// let cobrandedCards =   todo cancel button 
		$(DigitalMembershipCard.dmcActionsButton).hide();
		DigitalMembershipCard.dmcRemoveHiddenClass(DigitalMembershipCard.dmcPaymentTitle);
		DigitalMembershipCard.appendDmcTemplate(DigitalMembershipCard.dmcCvvScreenTemplate, DigitalMembershipCard.dmcContent, 
			
				DigitalMembershipCard.parameters(brand, displayAccountNumber, accountHolderName)
			
		);
		$('.dmc-input-field').each(function() {
			DigitalMembershipCard.addClassActive(this);
		});
		let dmcCobrandedCards = sessionStorage.getItem('dmc-cc-cards-hidden');
		$(DigitalMembershipCard.dmcContent).append('<div id="dmc-cc-cards-hidden">' + dmcCobrandedCards + '</div>').find('#dmc-cc-cards-hidden').addClass('hidden');
		
		DigitalMembershipCard.dmcMobileValidation();
		$('#cardExpiryDate').focus(function () {
		    this.placeholder='MM/YY';
		});
		$('#cardExpiryDate').blur(function () {
			if (!$('#cardExpiryDate').val()) {
				$('#cardExpiryDateLabel').removeClass('active');
			}
		    this.placeholder='';
		});
	},
	
	/**
	 * Calls openDialog method and pass particular parameters and in this case of back to membership button call
	 * to DmcPaymentJSONResponseCmd which exits the browser and returns to mobile app. 
	 * 
	 * */
	backToDigitalMembership: function() {
		if ($(DigitalMembershipCard.dmcRedPathForm).length > 0) {
			$(DigitalMembershipCard.dmcRedPathForm).submit();
		} else {
			DigitalMembershipCard.openDialog(
				messages.DMC_LEAVE_DMC_DIALOG_TITLE, 
				messages.DMC_LEAVE_DMC_DIALOG_TEXT, 
				messages.STAY_ON_PAGE_BUTTON, 
				messages.LEAVE_PAGE_BUTTON,
				'', 
				'DmcPaymentJSONResponseCmd'
			);	
		}
	
	},
	
	/**
	 * Calls openDialog method and pass particular parameters and in this case when user don't have any CC's it will open
	 * credit-card.html page where user can apply for new cards. 
	 * 
	 * */
	dmcApply: function() {
		DigitalMembershipCard.openDialog(
			messages.DMC_APPLY_DIALOG_TITLE, 
			messages.DMC_APPLY_DIALOG_TEXT, 
			messages.SUBMIT_CONTINUE, 
			messages.COSTCO_PAY_PAYMENT_REMOVE_MODAL_SECONDARY,
			'credit-card.html', 
			''
		);
	}, 
	
	/**
	 * Calls openDialog method and pass particular parameters and in this case of deprovision of default card call
	 * to DmcPaymentChangeProvisionStatusCmd which calls the deprovisionDmcPayment method from DmcHelper. 
	 * 
	 * */
	removeDefaultCard: function() {
		DigitalMembershipCard.openDialog(
			messages.COSTCO_PAY_PAYMENT_REMOVE_MODAL_TITLE, 
			messages.DMC_REMOVE_CARD_TEXT, 
			messages.COSTCO_PAY_PAYMENT_REMOVE_MODAL_PRIMARY, 
			messages.COSTCO_PAY_PAYMENT_REMOVE_MODAL_SECONDARY,
			'DmcPaymentChangeProvisionStatusCmd', 
			''
		);
		let membershipNumber = $('#memberCardNumber').val();
		let profileId = $('#profileId').val();
		let dmcInputHash = $('#dmcHash').val();
		let deviceType = $('#deviceType').val();
		let deviceId = $('#deviceId').val();
	
		$(DigitalMembershipCard.dmcDialogForm).append('<input name="actionProvision" type="hidden" value="deprovision"/>');
		$(DigitalMembershipCard.dmcDialogForm).append('<input name="membershipNumber" type="hidden" value="'+membershipNumber+'"/>');
		$(DigitalMembershipCard.dmcDialogForm).append('<input name="profileId" type="hidden" value="'+profileId+'"/>');
		$(DigitalMembershipCard.dmcDialogForm).append('<input name="dmcHash" type="hidden" value="'+dmcInputHash+'"/>');
		$(DigitalMembershipCard.dmcDialogForm).append('<input name="deviceType" type="hidden" value="'+deviceType+'"/>');
		$(DigitalMembershipCard.dmcDialogForm).append('<input name="deviceId" type="hidden" value="'+deviceId+'"/>');
	
	},
	
	/**
	 *  This method show user dialog loaded with different text and options based on parameters passed.
	 *  Based on which event is passed as empty that button will act as cancel button. Otherwise will submit 
	 *  the dialog form.
	 *  
	 * */
	openDialog: function( title, content, primaryButton, secondaryButton, primaryEvent, secondaryEvent) {
		
	      var settings = {
	        dialogclasses: 'dmc-dialog',
	        title: title,
	        body: COSTCO.util.tmpl(DigitalMembershipCard.dmcDialogTemplate, {
	        	content:content,
	        	action:primaryEvent != '' ? primaryEvent : secondaryEvent,
	            target:primaryEvent == 'credit-card.html' ? '_blank' : ''
	        }),
	        footerText: '',
	        preventClose: false,
	        primary: primaryButton,
	        secondary: secondaryButton,
	        primary_event: function primary_event() {
	        	if (primaryEvent != '') {
	        		$(DigitalMembershipCard.dmcDialogForm).submit();	
	        	}
	        	COSTCO.dialog.close();
	        },
	        secondary_event: function secondary_event() {
	        	if (secondaryEvent != '') {
	        		$(DigitalMembershipCard.dmcDialogForm).submit();	
	        	} 
	        	COSTCO.dialog.close();
	        },
	        close: function close() {
	            COSTCO.dialog.close();
	        },
	      };
	
	      COSTCO.dialog.createExtDialogBox(settings);
	},
	
	/**
	 * Remove class hidden for the passed selector.
	 * 
	 * @param selector
	 * */
	dmcRemoveHiddenClass: function(selector) {
		$(selector).removeClass('hidden');
	},
	
	/**
	 * Loads template based on the name passed as parameter and appends it to the div based on div ID. 
	 * Dmc options can be used as parameters for controling the behaviour of template actions or simply as 
	 * information that needs to passed to the template.
	 * 
	 * @param templateName, dmcDivId, dmcOptions
	 * */
	    appendDmcTemplate: function(templateName, dmcDivId, dmcOptions) {
	    	let template = $(COSTCO.util.tmpl(templateName, dmcOptions));
			$(dmcDivId).empty();
			$(dmcDivId).append(template);
	    },
	   
	    /**
	 * This is called from OTP flow only and it loads the template with choose buttons for user to retrieve new
	 * sms token so provision can be done. 
	 * Also invalidates session storage items entered in previous attempt. 
	 * */
	getAnotherOneSMSToken: function() {
		DigitalMembershipCard.appendDmcTemplate(DigitalMembershipCard.dmcProvisionOtpChooseTemplate, DigitalMembershipCard.dmcProvisioningContent, DigitalMembershipCard.parameters());
		$(DigitalMembershipCard.dmcActionsButton).removeClass('submit-token');
		sessionStorage.removeItem(DigitalMembershipCard.dmcValidationCodeExpired);
		sessionStorage.removeItem(DigitalMembershipCard.dmcValidationCodeExpTime);
		DigitalMembershipCard.bindDmcEvents();
	},
	
	/**
	 * Binding of different buttons. Choose button in OTP flow, Back to Membership Card button (dmcActionsButton), Cancel buttons etc..
	 * 
	 * */
	bindDmcEvents: function() {
		$(DigitalMembershipCard.dmcChooseButton).on('click keydown', function(event) {
			$(DigitalMembershipCard.dmcChooseButton).removeClass('active');
			$(this).closest(DigitalMembershipCard.dmcChooseButton).find(':radio').prop('checked', true);
			$(this).closest(DigitalMembershipCard.dmcChooseButton).addClass('active');
			$('#dmc-yp-choose-form > #dmc-hidden-inputs > #aliasId').val(this.getAttribute("aliasId"));
			$('#dmc-yp-choose-form > #dmc-hidden-inputs > #otpDeliveryOption').val(this.getAttribute("otpDeliveryOption"));
			$('#dmc-yp-add-token-form > #dmc-hidden-inputs > #otpDeliveryOption').val(this.getAttribute("otpDeliveryOption"));
		});
		
		$(DigitalMembershipCard.dmcActionsButton).on('click keydown', function(event) {
			if ($(DigitalMembershipCard.dmcActionsButton).hasClass('submit-token')) {
				DigitalMembershipCard.dmcTokenFieldValidation();
				if ($('#dmc-sms-token').val() != '') {
					$(DigitalMembershipCard.dmcAddTokenForm).submit();
				}
			} else if ($(DigitalMembershipCard.dmcActionsButton).hasClass(DigitalMembershipCard.dmcBackToDMCClass)) {
				$('#dmc-red-path-form').submit();
			} else {
				if ($(DigitalMembershipCard.dmcActionsButton).hasClass(DigitalMembershipCard.dmcOTPContinue)) {
			    	let aliasId = $("[type=radio][name='dmc-choose-verification-method']:checked").attr("aliasid");
					let otpDeliveryOption = $("[type=radio][name='dmc-choose-verification-method']:checked").attr("otpDeliveryOption");
					$('#dmc-yp-choose-form > #dmc-hidden-inputs > #aliasId').val(aliasId);
					$('#dmc-yp-add-token-form > #dmc-hidden-inputs > #aliasId').val(aliasId);
					$('#dmc-yp-choose-form > #dmc-hidden-inputs > #otpDeliveryOption').val(otpDeliveryOption);
					$('#dmc-yp-add-token-form > #dmc-hidden-inputs > #otpDeliveryOption').val(otpDeliveryOption);
				}
				$('#dmc-yp-choose-form').submit();
			}
			if (DigitalMembershipCard.flowId === DigitalMembershipCard.FLOWS.YELLOW_FLOW ){
				sessionStorage.removeItem(DigitalMembershipCard.dmcValidationCodeExpired);
				sessionStorage.removeItem(DigitalMembershipCard.dmcValidationCodeExpTime);
			}
		});
		
		$(DigitalMembershipCard.dmcCancelButton).on('click keydown', function(event) {
			$('#dmc-red-path-form').submit();
		});
		
		
		$(DigitalMembershipCard.dmcContent).on('click keydown','.dmc-box-regular', function(event) {
			event.stopImmediatePropagation();
			let brand = $(this).find('.brand').text();
			let displayAccountNumber = $(this).find('.display-account-number').text();
			let accountHolderName = $(this).find('.account-holder-name').text();
			let dmcCobrandedCards = $(DigitalMembershipCard.dmcContent).html();
			sessionStorage.setItem('dmc-cc-cards-hidden', dmcCobrandedCards);
			DigitalMembershipCard.loadCVVTemplate(brand, displayAccountNumber, accountHolderName);
			$('#dmc-yp-choose-form > #dmc-hidden-inputs > #displayAccountNumb').val(displayAccountNumber);
			
			DigitalMembershipCard.bindDmcEvents();
		});
		
		$('.dmc-input-field').on('focusout', function() {
			DigitalMembershipCard.addClassActive(this);
		});
		
	},
	
	addClassActive: function(inputField) {
		let cvvInputField = $(inputField);
		if (cvvInputField.val() != '' && cvvInputField.val() != undefined) {
			cvvInputField.addClass('active');
		}
	},
	
	/**
	 * Align co-branded cards in same line. Gets the max height and apply it to each div that contains the card. 
	 * 
	 */
	alignCardsBox: function() {
		let box = '#dmc-co-branded-cards';
	    let maxHeight = '';
	   
	    $(box).find('.dmc-box').each(function(index,item) {
	  	  let height = $(item).outerHeight();
	  	  if (maxHeight < height) {
	  		  maxHeight = height;
	  	  } 
	    });
	    
	    $('#dmc-co-branded-cards .dmc-box').css('height', maxHeight);
	    if (!COSTCO.Navigation_v2.isPhoneView()) {
	    	$('#dmc-co-branded-cards .dmc-box').addClass('cds-u-space-mr-xl');
		}
	    if($('#cardExpiryDate').val() !== undefined && $('#cardExpiryDate').val() !== ''){
			$('#cardExpiryDateLabel').addClass('active');
		}
		if($('#cvvNumber').val() !== undefined && $('#cvvNumber').val() !== ''){
			$('#cvvNumberLabel').addClass('active');
		}
		if($('#postalCode').val() !== undefined && $('#postalCode').val() !== ''){
			$('#postalCodeLabel').addClass('active');
		}
	},
	
	/**
	 * Single field validation. In OTP flow on sms Token screen.
	 *  
	 * */
	dmcTokenFieldValidation: function() {
		if ($('#dmc-sms-token').val() != '') {
			$('#dmc-sms-token').focus();
			let message = '';
			$.validator.addMethod("dmcTokenExpired", function (inputValue) {
				let isTokenExpired = sessionStorage.getItem(DigitalMembershipCard.dmcValidationCodeExpired);
				if (isTokenExpired == 'false') {
					return true;
				} else {
					return false;
				}
		    }, message = messages.ERR_OTP_DMC_EXPIRED_TOKEN);
			
			if($(DigitalMembershipCard.dmcAddTokenForm).validate()){
		    	$(DigitalMembershipCard.dmcAddTokenForm).validate().resetForm();
		    	$(DigitalMembershipCard.dmcAddTokenForm).validate();
		    	$('#dmc-sms-token').rules('add', 'dmcTokenExpired');
		    	$('#dmc-sms-token').valid();
			}
		}   
	},
	
	/**
	 * Counter that measure time from 10 minutes until the code is expired.
	 * Store the current time +Selected interval in this case 10 minutes in session storage and 
	 * call the getDistanceAndSetTimeRemaining method which return the distance from current time and stored value and checks
	 * if the distance is bigger than 0. 
	 *  
	 * */
	countDown: function() {
		let now = new Date().getTime();	
		let expTime = now + parseInt($('#dmcOtpTimer').val());
		
		if (typeof(Storage) !== "undefined") {
			if (sessionStorage.getItem(DigitalMembershipCard.dmcValidationCodeExpTime) !== null) {
				expTime = sessionStorage.getItem(DigitalMembershipCard.dmcValidationCodeExpTime);
			} else {
				sessionStorage.setItem(DigitalMembershipCard.dmcValidationCodeExpTime, expTime);
	    		sessionStorage.setItem(DigitalMembershipCard.dmcValidationCodeExpired, false);
			}
		}
		if (now > expTime) {
			$(DigitalMembershipCard.dmcTimer).text(DigitalMembershipCard.dmcCountDownFinishedMessage);
			sessionStorage.setItem(DigitalMembershipCard.dmcValidationCodeExpired, true);
			DigitalMembershipCard.dmcTokenFieldValidation();
		} else {
			// Update the count down every 1 second
			let x = setInterval(function() {
				let distance = DigitalMembershipCard.getDistanceAndSetTimeRemaining(expTime);
				if (distance < 0) {
					clearInterval(x);
				}
			}, 1000);	
		}
		
	},
	/**
	 * get distance from current time and event expiration time
	 * set time remaining in minutes nad seconds
	 * 
	 * @param expirationTime
	 * @return distance
	 */
	getDistanceAndSetTimeRemaining: function(expirationTime) {
		
		let now = new Date().getTime();				    
		let distance = expirationTime - now;
	    
		let minutes = Math.floor(distance  / (1000 * 60));
		let seconds = Math.floor((distance % (1000 * 60)) / 1000);
		let timeRemaining = minutes + " minutes and " + ((seconds < 10) ? "0" + seconds : seconds)+ " seconds" ;
			if (minutes > 0 || seconds > 0) {
				$(DigitalMembershipCard.dmcTimer).text(timeRemaining);
			}
			else {
				$(DigitalMembershipCard.dmcTimer).text(DigitalMembershipCard.dmcCountDownFinishedMessage);
				sessionStorage.setItem(DigitalMembershipCard.dmcValidationCodeExpired, true);
				DigitalMembershipCard.dmcTokenFieldValidation();
			}
			
			return distance;
		},
	
	verifyYourMembership: function() {
		COSTCO.AccountDetails.memberVerification();
	},	
		
	/**
	 * Dmc validation for CVV form check for expiry date and if it is in past, cvv length and value
	 * and Zipcode pattern. 
	 * 
	 * */
	dmcMobileValidation: function() {
	      $.validator.addMethod("cvv", function( value, element ) {
			if (value.trim().length == 3)
				return true;
			else {
				element.value='';
				return false;
				}
		  },  messages.ERR_INVALID_CVV);
	 
	      $.validator.addMethod('checkExpiryDate', function(value, element) {
				if(this.optional(element) || (/^(0[1-9]|1[012])\/([123]\d)$/).test(value))
					return true;
					else {
						element.value='';
						return false;
					}
			},  messages.ERR_INVALID_DATE);
		
		$.validator.addMethod("checkIsDateInPast", function(value, element) {
			let enteredMonth = parseInt(value.split('/')[0]);
			let enteredYear = parseInt(value.split('/')[1]);
			let now = new Date();
			let currentMonth = parseInt((now.getMonth() + 1).toString());
			let currentYear = parseInt(now.getFullYear().toString().substr(-2));
			if (enteredYear < currentYear || (enteredYear == currentYear && enteredMonth < currentMonth)) {
				element.value='';
			 	return false;
			} else{
				return true;
			}
		},  messages.ERR_INVALID_DATE);
		
		$.validator.addMethod('countryspecificpostalcode', function(value, element, params) {
			let zip_pattern = new RegExp(document.getElementById('zipcode_patterns').getAttribute('value'));
			if (this.optional(element) || zip_pattern.test($.trim(value)))
				return true;
			else {
				element.value='';
				return false;
			}
		}, messages.ERR_INVALID_DELIVERY_ZIP_CODE);
		
	      $('#dmc-add-cc-form').validate({
	    	  onkeyup: false,
		        rules: {
		          cardExpiryDate: {
		            required: true,
		            checkExpiryDate: true,
		            checkIsDateInPast: true,	
		          },
		          cvvNumber: {
		            required: true,
		            cvv: true,
		          },
		          postalCode: {
		            required: true,
		            countryspecificpostalcode: true,
		          },
		        },
		        messages: {
		          cardExpiryDate: {
		            required: messages.ERR_INVALID_DATE,
		          },
		          cvvNumber: {
		            required: messages.ERR_INVALID_CVV,
		          },
		          postalCode: {
		            required: messages.ERR_INVALID_DELIVERY_ZIP_CODE,
		          },
		        },
		        submitHandler: function(form) {
		          form.submit();
		        }.bind(this),
		      });
		   },
	  }
	 
	if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	}
	window.COSTCO.DigitalMembershipCard = DigitalMembershipCard;
	return DigitalMembershipCard;
		return DigitalMembershipCard;
	});



// WEBPACK FOOTER //
// ./js/account/digital-membership-card.js